enum Headset {
  /** viaim Nano+ */
  NANOPLUS = 'A91',

  /** viaim RecDot */
  RECDOT = 'A92',

  /** viaim RecDot2 */
  RECDOT2 = 'A96',

  /** viaim Notekit */
  NOTEKIT = 'D95',

  /** viaim Air */
  NANOAIR = 'E94',

  /** viaim OpenNote */
  OPENNOTE = 'E97'
}

export default Headset
